import { Navigate, useLocation } from "react-router-dom";
import { canAccessAdminPath, isLoggedIn } from "../../lib/auth";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!isLoggedIn()) return <Navigate to="/adxm/login" replace />;
  if (!canAccessAdminPath(location.pathname)) return <Navigate to="/adxm/dashboard" replace />;
  return children;
}
